import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { PalmettoGroups } from '@/common/types/auth.types';

const APIBaseURL = 'https://palmetto-wab.s3.amazonaws.com/s3db/groups.json';

export const palmettoGroupApi = createApi({
  reducerPath: 'palmettoGroupApi',
  baseQuery: fetchBaseQuery({ baseUrl: APIBaseURL }),
  endpoints: (builder) => ({
    getPalmettoGroups: builder.query<PalmettoGroups[], void>({
      query: () => ({
        url: '',
      }),
    }),
  }),
});

export const { useGetPalmettoGroupsQuery, useLazyGetPalmettoGroupsQuery } = palmettoGroupApi;
